export const ALLOWED_LOCALES = ['de', 'en'] as const;

export type Locale = (typeof ALLOWED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'de';

export function isLocale(value: unknown): value is Locale {
  return (
    typeof value === 'string' &&
    (ALLOWED_LOCALES as readonly string[]).includes(value)
  );
}

export function parseLocale(
  value: unknown,
  fallback: Locale = DEFAULT_LOCALE
): Locale {
  return isLocale(value) ? value : fallback;
}
